import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import { H1, TextP } from '../../primitives';
import TravelDocumentationReminder from './TravelDocumentationReminder';

const BookingConfirmation = ({ reservationSummaryText }) => (
  <Box as="article">
    <H1>Your hotel booking is confirmed</H1>
    <TextP color="#555" my={1}>
      You’re staying <strong>{reservationSummaryText}</strong>.
    </TextP>
    <TravelDocumentationReminder />
    <TextP color="#555" my={1}>
      Enjoy your trip.
    </TextP>
  </Box>
);

BookingConfirmation.propTypes = {
  reservationSummaryText: PropTypes.string.isRequired,
};

export default BookingConfirmation;
